/**
 * Rafraîchit le JWT access via /auth/refresh/ (SimpleJWT).
 * Gère ROTATE_REFRESH_TOKENS : sauvegarde le nouveau refresh s’il est renvoyé.
 */

import { getApiBaseUrl, getApiVersion } from '../../../shared/api/runtimeConfig'
import {
  clearTokens,
  getRefreshToken,
  setAccessToken,
  setTokens,
} from './tokenStorage'

const API_URL = getApiBaseUrl()
const API_VERSION = getApiVersion()

let refreshInFlight: Promise<boolean> | null = null

export async function refreshAccessToken(): Promise<boolean> {
  if (refreshInFlight) return refreshInFlight

  refreshInFlight = (async () => {
    const refresh = getRefreshToken()
    if (!refresh) return false
    try {
      const response = await fetch(`${API_URL}/${API_VERSION}/auth/refresh/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh }),
      })
      if (!response.ok) {
        clearTokens()
        return false
      }
      const data = (await response.json().catch(() => ({}))) as {
        access?: string
        refresh?: string
      }
      if (!data.access) {
        clearTokens()
        return false
      }
      if (data.refresh) {
        setTokens({ access: data.access, refresh: data.refresh })
      } else {
        setAccessToken(data.access)
      }
      return true
    } catch {
      return false
    } finally {
      refreshInFlight = null
    }
  })()

  return refreshInFlight
}

export function isAuthTokenErrorMessage(message: string | null | undefined): boolean {
  if (!message) return false
  const m = message.toLowerCase()
  return (
    m.includes('given token not valid')
    || m.includes('token is invalid')
    || m.includes('token not valid')
    || m.includes('token_not_valid')
    || m.includes('authentication credentials were not provided')
    || m.includes('detail":"given token')
  )
}
